import React, { useRef } from "react";
import { Button } from "antd";
import { QRCodeCanvas } from "qrcode.react";
import { FaCheckCircle, FaDownload } from "react-icons/fa";
import { bookingService } from "../../../services/bookingService";
import styles from "./AppointmentQR.module.css";

const AppointmentQR = ({ appointment, onReset, onClose }) => {
  const qrRef = useRef(null);

  const handleDownload = () => {
    const canvas = qrRef.current;
    if (!canvas) return;
    const url = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = `ma-hen-kham-${appointment.code}.png`;
    a.click();
  };

  const summaryFields = [
    { label: "Họ tên:", value: appointment.hoTen },
    { label: "Ngày khám:", value: appointment.ngayKham },
    { label: "Khung giờ:", value: appointment.khungGio },
    { label: "Bác sỹ:", value: appointment.bacSy },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FaCheckCircle className={styles.successIcon} />
        <h3 className={styles.headerTitle}>Đặt lịch thành công!</h3>
      </div>

      <div className={styles.qrBox}>
        <QRCodeCanvas
          ref={qrRef}
          value={`MDQR_${bookingService.buildQrValue(appointment)}`}
          size={180}
          level="M"
          marginSize={2}
        />
      </div>

      <div className={styles.codeWrap}>
        <div className={styles.codeLabel}>Mã hẹn khám:</div>
        <div className={styles.codeValue}>{appointment.code}</div>
      </div>

      {summaryFields.some((f) => f.value) && (
        <div className={styles.summary}>
          {summaryFields.map(
            (f) =>
              f.value && (
                <div key={f.label} className={styles.summaryItem}>
                  <span className={styles.summaryLabel}>{f.label}</span>
                  <span className={styles.summaryValue}>{f.value}</span>
                </div>
              ),
          )}
        </div>
      )}

      <div className={styles.noteBox}>
        Vui lòng lưu lại mã QR này. Xuất trình mã QR tại quầy tiếp đón của bệnh
        viện khi đến khám để hoàn tất đăng ký.
      </div>

      {appointment.isOffline && (
        <div className={styles.offlineNote}>
          Lịch hẹn đã được lưu tạm thời. Vui lòng xuất trình mã QR tại bệnh viện
          — nhân viên tiếp đón sẽ xác nhận và hoàn tất đăng ký cho bạn.
        </div>
      )}

      <div className={styles.actions}>
        <Button
          type="primary"
          icon={<FaDownload />}
          block
          style={{ minHeight: 44 }}
          onClick={handleDownload}
        >
          Tải mã QR
        </Button>
        <div className={styles.actionRow}>
          <Button onClick={onReset} style={{ minHeight: 44 }}>
            Đặt lịch khác
          </Button>
          {onClose && (
            <Button onClick={onClose} style={{ minHeight: 44 }}>
              Đóng
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentQR;
